// import axios from '../plugins/axios'
const state = {
  add_modal : false,
  edit_modal: false,
  id: null,
  is_view_mode: null,
}
const getters = {
  getDataByKey: (state) => (key) => {
    return state[key]
  }
}
const  actions = {

}
const mutations = {
  setData(state,data){
    state[data.key] = data.value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}